const redirectingToLogin = 'We are redirecting you to the login page...';

export const msalStatusMessages = {
  redirectingToLogin,
};
